import { StatusOption } from '../../utils'

export enum StaffApplicationStatusEnum {
  STAND_BY = 'STAND_BY',
  TO_BE_ASSIGNED_TO_PCR = 'TO_BE_ASSIGNED_TO_PCR',
  TO_BE_CONTACTED = 'TO_BE_CONTACTED',
  FIRST_CONTACT_ESTABLISHED = 'FIRST_CONTACT_ESTABLISHED',
  SECOND_CONTACT_ESTABLISHED = 'SECOND_CONTACT_ESTABLISHED',
  THIRD_CONTACT_ESTABLISHED = 'THIRD_CONTACT_ESTABLISHED',
  CLASSIFIED = 'CLASSIFIED',
  INTERVIEW_SCHEDULED = 'INTERVIEW_SCHEDULED',
  INTERVIEW_DONE = 'INTERVIEW_DONE',
  REJECTED_BEFORE_INTERVIEW = 'REJECTED_BEFORE_INTERVIEW',
  REJECTED_AFTER_INTERVIEW = 'REJECTED_AFTER_INTERVIEW',
  ACCEPTED = 'ACCEPTED'
}

export const staffApplicationStatusEnumMapping: Record<StaffApplicationStatusEnum, StatusOption> =
  {
    ACCEPTED: {
      label: 'Accepté',
      variant: 'success'
    },
    CLASSIFIED: {
      label: 'Classé sans suite',
      variant: 'grey'
    },
    FIRST_CONTACT_ESTABLISHED: {
      label: '1er contact',
      variant: 'purple'
    },
    SECOND_CONTACT_ESTABLISHED: {
      label: '2ème contact',
      variant: 'purple'
    },
    THIRD_CONTACT_ESTABLISHED: {
      label: '3ème contact',
      variant: 'violet'
    },
    INTERVIEW_DONE: {
      label: 'Entretien terminé',
      variant: 'blue'
    },
    INTERVIEW_SCHEDULED: {
      label: 'Entretien planifié',
      variant: 'fushia'
    },
    REJECTED_AFTER_INTERVIEW: {
      label: 'Refus après entr',
      variant: 'secondaryRed'
    },
    REJECTED_BEFORE_INTERVIEW: {
      label: 'Refus pré-entr',
      variant: 'danger'
    },
    STAND_BY: {
      label: 'Stand by',
      variant: 'grey'
    },
    TO_BE_ASSIGNED_TO_PCR: {
      label: 'A traiter',
      variant: 'darkBlue'
    },
    TO_BE_CONTACTED: {
      label: 'À contacter par PCR',
      variant: 'warning'
    }
  }
